// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1FBLn","content":"styles_content__2fjLt","checkbox":"styles_checkbox__5fIGi","checkboxLabel":"styles_checkboxLabel__2Y40L"};